<!-- Do not change this file. -->
<template>
  <div>
    <AlertConnectionLost v-if="!isOnline" />
    <div v-if="getToken != ''">
      <AlertSessionExpired v-if="isExpired" />
      <AlertSessionExpiring
        :minutes="minutes"
        v-else-if="timeRemaining <= secondsRemaining"
      />
      <APIHandler v-if="!hasError" />
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import config from "@/data/config.json";

import APIHandler from "@/components/core/APIHandler.vue";
import AlertConnectionLost from "@/components/core/AlertConnectionLost.vue";
import AlertSessionExpired from "@/components/core/AlertSessionExpired.vue";
import AlertSessionExpiring from "@/components/core/AlertSessionExpiring.vue";

export default {
  name: "SessionHandler",
  components: {
    APIHandler,
    AlertConnectionLost,
    AlertSessionExpired,
    AlertSessionExpiring
  },
  data() {
    return {
      config,
      onLine: navigator.onLine,
      timeRemaining: 0,
      minutes: 10
    };
  },
  computed: {
    ...mapGetters([
      "getExpirationTime",
      "getToken",
      "getExpirationTimeRemaining"
    ]),
    isOnline() {
      return navigator.onLine || this.online;
    },
    isExpired() {
      return this.timeRemaining <= 0;
    },
    hasError() {
      if (!this.isOnline) {
        return true;
      }

      if (this.isExpired) {
        return true;
      }

      return false;
    },
    secondsRemaining() {
      return config.sessionExpirationWarning * 60;
    }
  },
  methods: {
    checkConnectionStatus() {
      this.onLine = navigator.onLine;
    },
    checkTimeRemaining() {
      let secondsRemaining =
        this.getExpirationTime - Math.floor(Date.now() / 1000);

      this.timeRemaining = secondsRemaining;
      setTimeout(() => {
        this.checkTimeRemaining();
      }, 5000);
    }
  },
  watch: {
    getToken() {
      this.checkTimeRemaining();
    },
    getONID() {
      window.BugHerdConfig = window.BugHerdConfig || {};
      window.BugHerdConfig.feedback = { tab_position: "bottom-left" };
      window.BugHerdConfig.reporter = window.BugHerdConfig.reporter || {};
      window.BugHerdConfig.reporter.required = "true";
      window.BugHerdConfig.reporter.email = `${this.getONID}@oregonstate.edu`;
    }
  },
  created() {
    window.addEventListener("offline", this.checkConnectionStatus);
    window.addEventListener("online", this.checkConnectionStatus);
  }
};
</script>
